exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1Xmpc5QTpsm4yoZPEu20-6{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;height:20px}._1Xmpc5QTpsm4yoZPEu20-6 ._26kecDwmArwdhtJKRsyWWR{font-size:8px}html[dir=ltr] ._1Xmpc5QTpsm4yoZPEu20-6 ._26kecDwmArwdhtJKRsyWWR{margin-right:10px}html[dir=rtl] ._1Xmpc5QTpsm4yoZPEu20-6 ._26kecDwmArwdhtJKRsyWWR{margin-left:10px}._1Xmpc5QTpsm4yoZPEu20-6 .yDL8NQbxDKeFqhtLNZdru{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:210px}", ""]);

// exports
exports.locals = {
	"optionWrapper": "_1Xmpc5QTpsm4yoZPEu20-6",
	"coloredBullet": "_26kecDwmArwdhtJKRsyWWR",
	"optionLabel": "yDL8NQbxDKeFqhtLNZdru"
};